<template>
  <div>
    <div class="modals">
      <ModalWorkpachages :excludePackageMessage="excludePackageMessage()" />
    </div>
    <div v-if="pageData" class="tech-map-page">
      <div
        ref="sticky"
        :class="[
          'tech-map-page__sticky-header',
          {'tech-map-page__sticky-header_position' : $store.state.vinSearchData.modelOpenCampaignsMessage}
        ]"
      >
        <BackgroundDesctop class="tech-map-page__arrow-first" />
        <BackgroundDesctopSecond class="tech-map-page__arrow-second" />

        <BackgroundTablet class="tech-map-page__arrow-first_tablet" />
        <BackgroundTabletSecond class="tech-map-page__arrow-second_tablet" />

        <BackgroundMobile class="tech-map-page__arrow-mobile" />
        <div class="container-wrapper">
          <BaseButton
            type="secondary"
            class="tech-map-page__prev"
            @click.native="goBack"
          >
            {{ pageData.backButtonText }}
          </BaseButton>

          <CarInfo
            :image="{ src: pageData.car.image, alt: pageData.car.year}"
            :name="pageData.car.year"
            :modificationSupport="pageData.car.modification"
            :title="pageData.title"
            reverse
          />

          <NotificationBanner
            v-if="$store.state.vinSearchData.modelOpenCampaignsMessage"
            :msg="$store.state.vinSearchData.modelOpenCampaignsMessage"
            class="tech-map-page__notification"
          />

          <PeriodRange
            v-model="currentFilter.period"
            :title="pageData.range.title"
            :steps="pageData.range.steps"
            class="tech-map-page__range"
          />
        </div>
      </div>

      <div class="container-wrapper">
        <section class="container">
          <div class="tech-map-page__filters">
            <div class="tech-map-page__dropdowns">
              <BaseSelect
                v-model="currentFilter.city"
                :label="pageData.filters.labels.city"
                :items="citiesList"
                :desabled="routerParams.city ? true : false"
                needActive
                class="tech-map-page__dropdown"
                @isOpen="addMargin"
              />
              <BaseSelect
                v-if="dealersList"
                :key="JSON.stringify(dealersList)"
                v-model="currentFilter.dealer"
                :label="pageData.filters.labels.dealer"
                :items="dealersList"
                :desabled="routerParams.dealer ? true : false"
                needActive
                class="tech-map-page__dropdown"
              />
            </div>
          </div>
        </section>
      </div>

      <transition name="fade-slow" mode="out-in">
        <section
          v-if="isResultVisible"
          class="tech-map-page__content"
        >
          <TechMapFiltrationResult
            :oilsPayload="oil"
            :componentData="resultsData"
            :currentFilter="currentFilter"
            :oilChange="onOilChange"
            :arrayOil="arrayOil"
            @oilChange="onOilChange"
          />
        </section>
      </transition>
    </div>
  </div>
</template>

<script>
  // Step 4

  import { mapGetters, mapActions } from 'vuex'
  import CarInfo from '@/components/CarInfo'
  import PeriodRange from '@/components/PeriodRange'
  import TechMapFiltrationResult from '@/components/TechMapFiltrationResult'
  import NotificationBanner from '@/components/NotificationBanner'
  import { get } from 'lodash'
  import StickyEvents from 'sticky-events'
  import BackgroundDesctop from '@/assets/img/icons/background-arrow-desctop.svg?inline'
  import BackgroundDesctopSecond from '@/assets/img/icons/background-arrow-desctop-second.svg?inline'
  import BackgroundTablet from '@/assets/img/icons/background-arrow-tablet.svg?inline'
  import BackgroundTabletSecond from '@/assets/img/icons/background-arrow-tablet-second.svg?inline'
  import BackgroundMobile from '@/assets/img/icons/background-arrow-mobile.svg?inline'
  import ModalWorkpachages from '@/components/modal/ModalWorkpackages'

  export default {
    name: 'TechMapPage',

    components: {
      CarInfo,
      PeriodRange,
      TechMapFiltrationResult,
      BackgroundDesctop,
      BackgroundDesctopSecond,
      BackgroundTablet,
      BackgroundTabletSecond,
      BackgroundMobile,
      NotificationBanner,
      ModalWorkpachages
    },

    data () {
      return {
        showResults: false,
        pageData: null,
        resultsData: null,
        routerParams: {},
        currentFilter: {
          period: this.$route.query.period || '',
          city: this.$route.query.city || '',
          dealer: this.$route.query.dealer || ''
        },
        oil: '',
        oilChangeFirstTime: true,
        arrayOil: []
      }
    },

    computed: {
      ...mapGetters([
        'getModel',
        'getYear',
        'getModification',
        'getPeriod',
        'getCity',
        'getAliasParamCity',
        'getDealer',
        'getAliasParamDealer',
        'getWorkpackages',
        'isDesktop'
      ]),
      citiesList () {
        return this.pageData.filters.list
          .map(item => { return { text: item.text, value: item.value } })
      },
      dealersList () {
        const currentCity = this.pageData.filters.list
          .filter(city => city.value === this.currentFilter.city)

        return get(currentCity, [0, 'dealers']) ||
          [{ text: this.citiesList[0].text, value: null }] // make sure that this.citiesList[0] is 'not-selected' (null) value
      },
      backButton () {
        const text = this.pageData.backButtonText
        let route

        // if was search by vin code - back to model page
        if (this.$store.state.vinSearchData.modelOpenCampaignsMessage) {
          route = { name: 'model' }
        } else {
          route = {
            name: 'modification',
            params: {
              model: this.getModel,
              year: this.getYear
            }
          }
        }

        return { text, route }
      },
      isResultVisible () {
        return this.showResults &&
          this.currentFilter.period &&
          this.currentFilter.city &&
          this.currentFilter.dealer &&
          this.resultsData
      }
    },

    watch: {
      'getWorkpackages': {
        handler: function (search) {
          if (!this.oilChangeFirstTime) {
            this.fetchResultsPackages()
          }
        },
        deep: true,
        immediate: true
      },
      'currentFilter.period': {
        handler: function (val) {
          this.arrayOil = []
        },
        deep: true
      },
      currentFilter: {
        deep: true,
        handler (newValue) {
          this.oilChangeFirstTime = true

          const { period, city, dealer } = newValue

          if (JSON.stringify(newValue) !== JSON.stringify(this.$route.query)) {
            this.$router.push({
              query: { period, city, dealer }
            })
          }

          if (period && city && dealer) {
            this.fetchResults()
          }

          if (!city) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        }
      },
      async pageData (v) {
        if (v && this.$refs.sticky) {
          await this.$nextTick()

          const stickyEvents = new StickyEvents({
            enabled: true,
            stickySelector: '.tech-map-page__sticky-header'
          })

          stickyEvents.enableEvents()

          const { stickyElements } = stickyEvents

          stickyElements.forEach(sticky => {
            sticky.addEventListener(StickyEvents.CHANGE, (event) => {
              sticky.classList.toggle('tech-map-page__sticky-header_stuck', event.detail.isSticky)
            })
          })
        }
      },
      isResultVisible (v) {
        if (v) {
          const lang = get(this, '$store.state.general.lang', '') || get(this, '$store.state.general.locales[0].code', '')
          this.language = lang === 'ua' ? 'uk' : lang

          this.pushDataToDataLayer({
            events: {
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'service-summary'
              }
            },
            pages: {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language: this.language
              }
            },
            forms: {
              form: {
                name: 'lead-book-service',
                step: 'service-summary',
                conversion: '0'
              }
            },
            products: {
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: this.stateModelId,
                  productName: this.stateModelName,
                  tmeModelId: this.stateModelId,
                  modelName: this.stateModelName
                }
              }]
            }
          }, true)
        }
      },
      $route (to, from) {
        if (from.name === 'service-request' && to.name === 'tech-map') {
          const lang = get(this, '$store.state.general.lang', '') || get(this, '$store.state.general.locales[0].code', '')
          this.language = lang === 'ua' ? 'uk' : lang

          this.pushDataToDataLayer({
            events: {
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'select-service'
              }
            },
            pages: {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language: this.language
              }
            },
            forms: {
              form: {
                name: 'lead-book-service',
                step: 'select-service',
                conversion: '0'
              }
            },
            products: {
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: this.stateModelId,
                  productName: this.stateModelName,
                  tmeModelId: this.stateModelId,
                  modelName: this.stateModelName
                }
              }]
            }
          }, true)
        }
      }
    },

    async mounted () {
      this.routerParams = {
        city: this.getCity || this.getAliasParamCity || '',
        dealer: this.getDealer || this.getAliasParamDealer || ''
      }

      const data = await this.fetchTechMapPageData({
        modification: this.getModification
      })

      // set data from BE
      this.pageData = { ...data }

      // fill filters from url if exists
      this.currentFilter = {
        period: this.getPeriod || '',
        city: this.getCity || this.getAliasParamCity || '',
        dealer: this.getDealer || this.getAliasParamDealer || ''
      }

      // set info to tech card
      if (this.$route.query.period && this.$route.query.city && this.$route.query.dealer) {
        this.fetchResults()
      }
    },

    deactivated () {
      this.oilChangeFirstTime = false
    },

    activated () {
      // this.$router.push({
      //   query: {
      //     period: this.currentFilter.period,
      //     city: this.currentFilter.city,
      //     dealer: this.currentFilter.dealer
      //   }
      // })
    },

    methods: {
      ...mapActions(['fetchTechMapPageData', 'fetchTechMapResultsData']),

      excludePackageMessage () {
        return get(this.resultsData, 'tables.required.excludePackageMessage', '')
      },
      async fetchResultsPackages () {
        const results = await this.fetchTechMapResultsData({
          workpackages: this.$route.query.workpackages || null,
          period: this.currentFilter.period,
          dealer: this.currentFilter.dealer,
          oil: this.arrayOil.filter(item => item).join(',')
        })
        this.resultsData = { ...results }
      },

      async fetchResults (oil, itsInit = true) {
        if (itsInit) {
          this.showResults = false
        }
        const results = await this.fetchTechMapResultsData({
          workpackages: this.$route.query.workpackages || null,
          period: this.currentFilter.period,
          dealer: this.currentFilter.dealer,
          oil
        })
        this.resultsData = { ...results }
        if (itsInit) {
          this.showResults = true
        }
      },

      async onOilChange (oil, column) {
        if (column) {
          this.arrayOil[column] = oil
        }
        if (this.oil) {
          this.oilChangeFirstTime = false
        }

        if (!this.oilChangeFirstTime && this.oil !== oil) {
          if (String(this.oil) !== String(oil)) {
            await this.fetchResults(this.arrayOil.filter(item => item).join(','), false)
          }
        }

        this.$store.commit('SET_OIL_ID', this.arrayOil.filter(item => item).join(','))

        this.oil = oil
        this.setCityDealer()
        this.setIdDealer()
        this.setNameDealer()
        this.setZipCodeDealer()

        this.$store.commit('SET_DEALER', {
          dealerName: this.dealerName,
          dealerId: this.dealerId,
          dealerCity: this.dealerCity,
          dealerZipCode: this.dealerZipCode
        })
      },

      goBack () {
        this.$router.push({ name: 'modification' })

        const lang = get(this, '$store.state.general.lang', '') || get(this, '$store.state.general.locales[0].code', '')
        this.language = lang === 'ua' ? 'uk' : lang

        this.pushDataToDataLayer({
          events: {
            event: {
              name: 'formevent',
              componentName: 'book-service',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'select-grade'
            }
          },
          pages: {
            page: {
              category: 'tools',
              subCategory: 'form',
              sectionlv1: 'forms',
              sectionlv2: 'book-service',
              language: this.language
            }
          },
          forms: {
            form: {
              name: 'lead-book-service',
              step: 'select-grade',
              conversion: '0'
            }
          },
          products: {
            product: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.stateModelId,
                productName: this.stateModelName,
                tmeModelId: this.stateModelId,
                modelName: this.stateModelName
              }
            }]
          }
        }, true)
      },

      addMargin (v) {
        const dropdownWrap = document.querySelector('.tech-map-page__dropdowns')
        const openedSelect = document.querySelector('.select__dropdown_scrollbar_custom')

        if (v && this.isDesktop) {
          dropdownWrap.style.marginBottom = `${openedSelect.offsetHeight}px`
        } else {
          dropdownWrap.style.marginBottom = `60px`
        }
      },

      pushDataToDataLayer (params = {}, pushDataLayer = false) {
        window.dataLayer = window.dataLayer || []

        const lang = get(this, '$store.state.general.lang', '') || get(this, '$store.state.general.locales[0].code', '')
        this.language = lang === 'ua' ? 'uk' : lang
        this.stateModelId = get(this, '$store.state.model.modelId', '') || get(this, 'pageData.car.modificationId', '')
        this.stateModelName = get(this, '$store.state.model.modelText', '') || get(this, 'pageData.car.modificationName', '')

        window.tngaDataLayer = { ...params.events, ...params.pages, ...params.forms, ...params.products }
        if (pushDataLayer) window.dataLayer.push({ 'event': 'formevent' })
      },
      checkNull (data) {
        if (data) return data
        return ''
      },
      setCityDealer () {
        this.dealerCity = this.checkNull(get(get(this, 'citiesList', []).find(item => item.value === get(this, 'currentFilter.city', '')), 'text', ''))
      },
      setIdDealer () {
        this.dealerId = get(this, 'currentFilter.dealer', '')
      },
      setNameDealer () {
        this.dealerName = this.checkNull(get(get(this, 'dealersList', []).find(item => item.value === this.dealerId), 'text', ''))
      },
      setZipCodeDealer () {
        this.dealerZipCode = this.checkNull(get(get(this, 'dealersList', []).find(item => item.value === this.dealerId), 'zipCode', ''))
      }
    }
  }
</script>

<style lang="scss">
  .tech-map-page {
    &__prev {
      min-width: 81px;
      margin-bottom: 80px;

      @include mobile {
        margin-bottom: 40px;
      }
    }

    &__arrow-first,
    &__arrow-second {
      position: absolute;
      top: -100px;

      @include tablet {
        display: none;
      }
    }

    &__arrow-first {
      right: 37vw;
    }

    &__arrow-second {
      right: 10.35vw;
    }

    &__arrow-first_tablet,
    &__arrow-second_tablet {
      position: absolute;
      top: -100px;
      display: none;

      @include tablet {
        display: block;
      }

      @include mobile {
        display: none;
      }
    }

    &__arrow-first_tablet {
      right: 31vw;
    }

    &__arrow-second_tablet {
      right: 0;
    }

    &__arrow-mobile {
      position: absolute;
      top: -60px;
      right: 0;
      display: none;

      @include mobile {
        display: block;
      }
    }

    &__sticky-header {
      position: static !important;
      top: 0;
      z-index: 9999;
      background: white;

      &::before {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        content: '';
        background: white;
      }

      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: -2;
        width: 100%;
        height: 5%;
        content: '';
        box-shadow: 0 1px 15px rgba($c-gray-dark, 0.5);
        opacity: 0;
        transition: opacity 0.3s;

        @include tablet {
          display: none;
        }
      }

      &_stuck {
        &::after {
          opacity: 1;
        }
      }

      &_position {
        top: -281px;

        @include tablet {
          top: -210px;
        }
      }

      @include tablet {
        // padding-top: 25px;
      }

      @include tablet {
        position: static !important;
      }
    }

    .car-info {
      @include tablet {
        margin-bottom: 40px;
      }
    }

    &__notification {
      margin-bottom: 60px;

      @include tablet {
        margin-bottom: 30px;
      }

      @include mobile {
        margin-bottom: 40px;
      }

      .notification-banner__text {
        max-width: 782px;
        padding: 40px 0;

        @include tablet {
          max-width: 100%;
          padding: 40px 50px;
        }

        @include mobile {
          padding: 40px 35px;
        }
      }
    }

    &__range {
      padding-bottom: 80px;

      @include tablet {
        padding-bottom: 60px;
      }
    }

    &__dropdowns {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 60px;

      @include mobile {
        flex-direction: column;
      }
    }

    &__dropdown {
      width: 100%;
      max-width: 500px;
      padding-bottom: 0;

      @include tablet {
        max-width: 320px;
      }

      @include mobile {
        min-width: 100%;
        max-width: 100%;

        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }

      &_disable {
        cursor: default;

        .select__field {
          @include hover {
            background-color: $c-gray-light !important;
          }
        }

        .select__arrow {
          display: none;
        }
      }
    }
  }
</style>
